import { AccountingExpense } from 'types';
import { formatPrice } from 'utils/helpers';
import {
  getSplAmountState,
  SPL_SHIPMENT_CATEGORY_NAME,
} from 'components/accounting-expenses-form/config';

import type { CarRentalField } from './car-rental';

// SPL Shipment (owner 22 Oct 2026: "needs to be like car rental"): the
// View Expense card shows "Estimated Amount" once the SPL invoice set the
// final amount, exactly as a final car rental does (car-rental.ts). An
// estimate still equal to the amount, or no estimate, shows nothing extra.
const isSplShipment = (name?: string | null) =>
  String(name ?? '')
    .trim()
    .toUpperCase() === SPL_SHIPMENT_CATEGORY_NAME.toUpperCase();

export const isSplShipmentExpense = (data?: AccountingExpense) =>
  Boolean(data?.categories?.some((category) => isSplShipment(category.name)));

export const getSplShipmentFields = (
  data?: AccountingExpense
): CarRentalField[] | null => {
  const estimate = data?.estimatedAmountCents;
  if (
    !isSplShipmentExpense(data) ||
    estimate == null ||
    getSplAmountState(data) !== 'final'
  ) {
    return null;
  }
  return [
    { title: 'Estimated Amount', value: formatPrice(Number(estimate) / 100) },
  ];
};

// The summary card's Amount title for an expense whose only category is
// SPL Shipment (a split keeps "Amount": that figure is the whole payment).
export const isSplShipmentOnly = (data?: AccountingExpense) =>
  data?.categories?.length === 1 && isSplShipment(data.categories[0].name);
